module.exports = __webpack_public_path__ + "img/unit_circle.25dadb84.png";